module.exports = __webpack_public_path__ + "img/barrierremoval.4c3d701b.svg";